// extracted by mini-css-extract-plugin
export var sbShowMain = "logotype-module--sb-show-main--1cToD";
export var logotype = "logotype-module--logotype--1vHRr";